import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"
import { debounce } from "../utilities"

export default class {
  constructor(el, options) {
    let msnry

    function setupGrid() {
      msnry = new Masonry(el, {
        gutter: ".js-masonryGutter",
        itemSelector: ".js-masonryItem",
        columnWidth: ".js-masonryItem",
        transitionDuration: 0,
      })
    }

    window.addEventListener("resize", debounce(setupGrid, 500))

    imagesLoaded(el, {}, setupGrid)

    setupGrid()
  }
}
